import {PUB_SUB_CHANNEL_APP} from '../../constants';
import {
  MODAL_TYPE_CREATE_GROUP,
  MODAL_TYPE_LEAVE_GROUP,
  MODAL_TYPE_NOTIFICATIONS_SETTINGS,
  MODAL_TYPE_EDIT_GROUP,
  MODAL_TYPE_ARCHIVE_GROUP,
  MODAL_TYPE_REPORT_GROUP,
  MODAL_TYPE_ADD_MEMBERS,
  MODAL_TYPE_SHARE_GROUP,
  PROXY_ACTION_TYPE_AUTH,
  PROXY_ACTION_TYPE_MESSAGE_POPUP,
} from './constants';
import {publishOpenedModalsMiddleware} from './middleware/publish-opened-modals-middleware';
import {publishStartedProxyActionsMiddleware} from './middleware/publish-started-proxy-actions-middleware';
import {onModalCloseMiddleware} from './middleware/on-modal-close-middleware';
import {onProxyActionEndMiddleware} from './middleware/on-proxy-action-end-middleware';
import {subscribeMiddleware} from './middleware/subscribe-middleware';
import {publishMiddleware} from './middleware/publish-middleware';
import {reducerForApp} from './reducers';
import {createShowModal} from './create-show-modal';
import {createStartProxyAction} from './create-start-proxy-action';

export const siteModalsBootstrap = {
  middleware: publicPubSub => {
    return [
      onModalCloseMiddleware,
      onProxyActionEndMiddleware,
      publishOpenedModalsMiddleware(publicPubSub),
      publishStartedProxyActionsMiddleware(publicPubSub),
      subscribeMiddleware(publicPubSub.on, publicPubSub.removeListener, PUB_SUB_CHANNEL_APP),
      publishMiddleware(publicPubSub.emit),
    ];
  },
  reducer: reducerForApp,
};

export const startProxyActionAuth = createStartProxyAction(PROXY_ACTION_TYPE_AUTH);
export const startProxyActionMessagePopup = createStartProxyAction(PROXY_ACTION_TYPE_MESSAGE_POPUP);

export const openModalCreateGroup = createShowModal(MODAL_TYPE_CREATE_GROUP);
export const openModalLeaveGroup = createShowModal(MODAL_TYPE_LEAVE_GROUP);
export const openModalArchiveGroup = createShowModal(MODAL_TYPE_ARCHIVE_GROUP);
export const openModalShareGroup = createShowModal(MODAL_TYPE_SHARE_GROUP);
export const openModalAddMembers = createShowModal(MODAL_TYPE_ADD_MEMBERS);
export const openModalReportGroup = createShowModal(MODAL_TYPE_REPORT_GROUP);
export const openModalEditGroup = createShowModal(MODAL_TYPE_EDIT_GROUP);
export const openModalNotificationsSettings = createShowModal(MODAL_TYPE_NOTIFICATIONS_SETTINGS);
